<ion-card>
    <ion-fab vertical="center" horizontal="end">
        <ion-row class="ion-no-margin ion-no-padding">
            <!--            <ion-col class="ion-no-margin ion-no-padding">-->
            <!--                <ion-fab-button *ngIf="mobileConfiguration && mobileConfiguration.mobilehireHealthCareInUse === 1"-->
            <!--                                (click)="scanBarcode()" size="small" color="light">-->
            <!--                    <ion-icon name="barcode"></ion-icon>-->
            <!--                </ion-fab-button>-->
            <!--            </ion-col>-->
            
            <ion-col class="ion-no-margin ion-no-padding"
                     *ngIf="mobileConfiguration && document.originalDocumentType != 4 && (document.documentType !== 8  || mobileConfiguration.mobilehireSimpleEquipOffhire !== 1)">
                <ion-fab-button (tap)="eqListModal()" size="small" color="light">
                    <ion-icon name="hammer"></ion-icon>
                </ion-fab-button>
            </ion-col>


        </ion-row>
    </ion-fab>
    <ion-card-content *ngIf="document.detailLines.length <= 0">
        <ion-label>Select Plant items/Consumables...</ion-label>
    </ion-card-content>

    <ion-card-content *ngIf="document.detailLines.length > 0">
        <ion-list>
            <ion-item-sliding *ngFor="let item of document.detailLines; index as i;">

                <!-- Changeover line -->
                <ion-item (click)="editItemQty(i)" *ngIf="item.changeOverDetailLine && item.changeOverDetailLine !==null ">
                    <ion-label [color]="item.qty < item.requiredQty ? 'danger' : 'dark'" class="ion-text-wrap">

                        <p>{{item.changeOverDetailLine.description}}</p>
                        <p *ngIf="item.changeOverDetailLine.pdesc">{{item.changeOverDetailLine.pdesc }} <span *ngIf="item.changeOverDetailLine.reg"> - {{item.changeOverDetailLine.reg}}</span></p>
                        <ion-icon color="none" name="arrow-down" slot="icon-only"></ion-icon>
                        <p>{{item.typ === 'M' || item.typ === 'P' || item.plu ? item.qty + ' x ' : '' }} {{item.description}}</p>
                        <p *ngIf="item.pdesc">{{item.pdesc }} <span *ngIf="item.reg"> - {{item.reg}}</span></p>
                   
                   
                    </ion-label>
                </ion-item>

                <!-- Normal Line -->
                <ion-item (click)="editItemQty(i)" *ngIf="( !item.changeOverDetailLine || item.changeOverDetailLine === null ) ">
                    <ion-label [color]="item.qty < item.requiredQty ? 'danger' : 'dark'" class="ion-text-wrap">
                        <p>{{item.typ === 'M' || item.typ === 'P' || item.plu ? item.qty + ' x ' : '' }} {{item.description}}</p>
                        <p *ngIf="item.pdesc">{{item.pdesc }} <span *ngIf="item.reg"> - {{item.reg}}</span></p>
                   
                   
                    </ion-label>
                </ion-item>

                <ion-item-options side="start">
                    <ion-item-option color="none" class="ion-float-right">
                        <ion-button color="danger" (click)="document.detailLines.splice(i,1)">
                            <ion-icon name="trash" slot="icon-only"></ion-icon>
                        </ion-button>
                    </ion-item-option>
                </ion-item-options>



            </ion-item-sliding>
        </ion-list>
    </ion-card-content>

</ion-card>

